var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 24V37.3333",
    stroke: "#D64444",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4992 57.0941H16.3392C7.08584 57.0941 3.21917 50.4807 7.69917 42.4007L16.0192 27.4141L23.8592 13.3341C28.6058 4.77406 36.3925 4.77406 41.1392 13.3341L48.9792 27.4407L57.2992 42.4274C61.7792 50.5074 57.8858 57.1207 48.6592 57.1207H32.4992V57.0941Z",
    stroke: "#D64444",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 45.334H32.5083",
    stroke: "#D64444",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertImg);
export default __webpack_public_path__ + "static/media/alert_img.46019848fde4be1488d0a1510c2345fc.svg";
export { ForwardRef as ReactComponent };